const initHeadingWithCard = () => {
    const headingWithCard = document.querySelector("[data-heading-with-card-carousel]");
    if (headingWithCard) {
        const config = new CarouselConfig();
        config.sliderSelector = "[data-heading-with-card-carousel]";
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showDots = true;
        config.groupCells = false;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        config.viewport = 1024;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
    //handle videos 
    if (document.querySelector("[data-heading-with-card-carousel] [data-desktop-src]")) {
        //desktop
        const widget = document.querySelector("[data-heading-with-card-carousel]");
        if (window.innerWidth > 768) {
            widget.querySelectorAll("[data-desktop-src]").forEach((video) => {
                const desktopSrc = video.getAttribute("data-desktop-src");
                video.src = desktopSrc;
            });
        }
        //mobile
        else {
            widget.querySelectorAll("[data-mobile-src]").forEach((video) => {
                const mobileSrc = video.getAttribute("data-mobile-src");
                video.src = mobileSrc;
            });
        }
    }
};
